import { render, staticRenderFns } from "./instagram-video-vs-reels-download.vue?vue&type=template&id=42ca6fc4"
import script from "./instagram-video-vs-reels-download.vue?vue&type=script&lang=js"
export * from "./instagram-video-vs-reels-download.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports